import { c as _c } from "react/compiler-runtime";
import React from 'react';
import BrandTooltip from 'components/consumer/BrandTooltip';
import IconGreenguardGold from './IconGreenguardGold';
const IconWithTooltipGreenguardGold = props => {
  const $ = _c(6);
  let t0;
  if ($[0] !== props) {
    t0 = <IconGreenguardGold {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="font-bold mb-2">GREENGUARD Gold Certified</div>;
    t2 = <p>This piece was screened for 10,000+ chemicals and emissions, contributing to cleaner air in your home.</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0) {
    t3 = <BrandTooltip openOnHover={true} textColor="brand" align="standard" direction="top" showInfoIcon={false} showCloseButton={false} leftOffsetOverride={0} customIcon={t0}>{t1}{t2}</BrandTooltip>;
    $[4] = t0;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default IconWithTooltipGreenguardGold;